import {ref} from 'vue';

/**
 * Состояние промо — синглтон вне дерева подписания.
 *
 * Диалог нельзя монтировать внутри <signer-sign>: после успешной подписи потребители
 * гасят модалку подписания и перечитывают список (invalidateQueries через 2 с), из-за чего
 * фича размонтируется вместе с промо — оно закрывалось само через пару секунд.
 */
const isOpen = ref<boolean>(false);

export function usePostSignPromo() {
    return {
        isOpen,
        open: () => {
            isOpen.value = true;
        },
        close: () => {
            isOpen.value = false;
        },
    };
}
